"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLink = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const page_link_styles_1 = require("./page_link.styles");
const PageLink = ({ title, onClick, active }) => {
    return ((0, jsx_runtime_1.jsxs)(page_link_styles_1.PageLinkButton, Object.assign({ "data-testid": `${title.toLowerCase()}-tab-container-button`, onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(page_link_styles_1.TabTitle, Object.assign({ active: active, size: "xlarge", bold: true }, { children: title })), (0, jsx_runtime_1.jsx)(page_link_styles_1.BlackBar, { active: active })] })));
};
exports.PageLink = PageLink;
//# sourceMappingURL=page_link.js.map